import * as React from "react";
import {VscContext} from "./ContentRendererJSX";
import {useContext} from "react";

export const VscReactContext = React.createContext<VscContext | null>(null);

export function useVscContext() {
    return useContext(VscReactContext)!;
}

